module.exports = __webpack_public_path__ + "images/heart.0162ff3d9c27bb1a1d92.png";